import { create } from 'zustand';

import type { ShowDialogPayload } from '@interfaces/common/dialogs';

type DialogStoreState = (
  | Pick<ShowDialogPayload, 'dialogTypes' | 'dialogProps'>
  | { dialogTypes: ''; dialogProps: undefined }
) & {
  onClose?: () => void;
  isFetching: boolean;
};

interface DialogStoreActions {
  show(payload: ShowDialogPayload): void;
  hide(): void;
  setIsFetching(isFetching: boolean): void;
}

type DialogStore = DialogStoreState & DialogStoreActions;

const initialState: DialogStoreState = {
  dialogTypes: '',
  dialogProps: undefined,
  onClose: undefined,
  isFetching: false,
};

export const useDialogStore = create<DialogStore>()((set) => ({
  ...initialState,
  show: (payload) =>
    set(() => ({
      dialogTypes: payload.dialogTypes,
      dialogProps: payload.dialogProps,
      onClose: payload.onClose,
      isFetching: false,
    })),
  hide: () => set(() => initialState),
  setIsFetching: (isFetching) => set(() => ({ isFetching })),
}));
